import { startOfTomorrow } from 'date-fns/startOfTomorrow';
import { getZonedDate } from '@eika-infrastruktur/date';
export var BankValidationOptions;
(function (BankValidationOptions) {
    BankValidationOptions["BIC"] = "BIC";
    BankValidationOptions["BANKCODE"] = "BANKCODE";
})(BankValidationOptions || (BankValidationOptions = {}));
export const MAX_ADDRESS_LENGTH = 70;
export const GB_COUNTRY_CODE = 'GB';
export const GB_CURRENCY = 'GBP';
const tomorrow = getZonedDate(startOfTomorrow());
export const crossBorderPaymentInitialState = {
    amount: undefined,
    country: undefined,
    currency: undefined,
    priority: 'STANDARD',
    chargeBearer: 'SHARED',
    transferCurrency: undefined,
    fromAccount: undefined,
    receiverName: '',
    messageReceiver: '',
    paymentDescription: '',
    regulatoryCode: undefined,
    paymentDate: undefined,
    firstBankingDateFromToday: tomorrow,
    receiver: undefined,
    bankValidation: undefined,
};
export const toSelectCrossBorderReceiver = (receiver) => {
    return {
        name: receiver.name,
        accountNumber: receiver.account.number,
        accountType: receiver.account.type,
        address: receiver.address,
        address2: receiver.address2,
        town: receiver.town,
        postcode: receiver.postcode,
        receiverCountryCode: receiver.countryCode,
        bankCountryCode: receiver.bank.countryCode,
        nationalId: receiver.bank.nationalId,
        bic: receiver.bank.bic,
        needBic: false,
        bankValidationOption: BankValidationOptions.BANKCODE,
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy90cmFuc2FjdGlvbi9Dcm9zc0JvcmRlclBheW1lbnQvZm9ybS9zdGF0ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sMEJBQTBCLENBQUM7QUFFM0QsT0FBTyxFQUFFLFlBQVksRUFBYSxNQUFNLDBCQUEwQixDQUFDO0FBNkVuRSxNQUFNLENBQU4sSUFBWSxxQkFHWDtBQUhELFdBQVkscUJBQXFCO0lBQzdCLG9DQUFXLENBQUE7SUFDWCw4Q0FBcUIsQ0FBQTtBQUN6QixDQUFDLEVBSFcscUJBQXFCLEtBQXJCLHFCQUFxQixRQUdoQztBQUVELE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLEVBQUUsQ0FBQztBQUNyQyxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsSUFBSSxDQUFDO0FBQ3BDLE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyxLQUFLLENBQUM7QUFFakMsTUFBTSxRQUFRLEdBQUcsWUFBWSxDQUFDLGVBQWUsRUFBRSxDQUFDLENBQUM7QUFFakQsTUFBTSxDQUFDLE1BQU0sOEJBQThCLEdBQTRCO0lBQ25FLE1BQU0sRUFBRSxTQUFTO0lBQ2pCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLFFBQVEsRUFBRSxTQUFTO0lBQ25CLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLFlBQVksRUFBRSxRQUFRO0lBQ3RCLGdCQUFnQixFQUFFLFNBQVM7SUFDM0IsV0FBVyxFQUFFLFNBQVM7SUFDdEIsWUFBWSxFQUFFLEVBQUU7SUFDaEIsZUFBZSxFQUFFLEVBQUU7SUFDbkIsa0JBQWtCLEVBQUUsRUFBRTtJQUN0QixjQUFjLEVBQUUsU0FBUztJQUN6QixXQUFXLEVBQUUsU0FBUztJQUN0Qix5QkFBeUIsRUFBRSxRQUFRO0lBQ25DLFFBQVEsRUFBRSxTQUFTO0lBQ25CLGNBQWMsRUFBRSxTQUFTO0NBQzVCLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSwyQkFBMkIsR0FBRyxDQUFDLFFBQTZCLEVBQTZCLEVBQUU7SUFDcEcsT0FBTztRQUNILElBQUksRUFBRSxRQUFRLENBQUMsSUFBSTtRQUNuQixhQUFhLEVBQUUsUUFBUSxDQUFDLE9BQU8sQ0FBQyxNQUFNO1FBQ3RDLFdBQVcsRUFBRSxRQUFRLENBQUMsT0FBTyxDQUFDLElBQUk7UUFDbEMsT0FBTyxFQUFFLFFBQVEsQ0FBQyxPQUFPO1FBQ3pCLFFBQVEsRUFBRSxRQUFRLENBQUMsUUFBUTtRQUMzQixJQUFJLEVBQUUsUUFBUSxDQUFDLElBQUk7UUFDbkIsUUFBUSxFQUFFLFFBQVEsQ0FBQyxRQUFRO1FBQzNCLG1CQUFtQixFQUFFLFFBQVEsQ0FBQyxXQUFXO1FBQ3pDLGVBQWUsRUFBRSxRQUFRLENBQUMsSUFBSSxDQUFDLFdBQVc7UUFDMUMsVUFBVSxFQUFFLFFBQVEsQ0FBQyxJQUFJLENBQUMsVUFBVTtRQUNwQyxHQUFHLEVBQUUsUUFBUSxDQUFDLElBQUksQ0FBQyxHQUFHO1FBQ3RCLE9BQU8sRUFBRSxLQUFLO1FBQ2Qsb0JBQW9CLEVBQUUscUJBQXFCLENBQUMsUUFBUTtLQUN2RCxDQUFDO0FBQ04sQ0FBQyxDQUFDIn0=